var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loadingCategories || !_vm.currentProduct
    ? _c("v-skeleton-loader", { attrs: { type: "actions" } })
    : _c(
        "div",
        [
          _c(
            "v-container",
            { staticClass: "mb-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { staticStyle: { "background-color": "#ffe1ce" } },
                [
                  _c("v-col", [
                    _c("h1", { staticClass: "text-center main-title" }, [
                      _vm._v(_vm._s(_vm.title))
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-container",
            { staticClass: "mt-3", attrs: { "grid-list-lg": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs12: "", sm6: "" } }),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: "navigation",
                          attrs: { flat: "", dense: "" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "pl-0",
                              attrs: { small: "", text: "" },
                              on: { click: _vm.backButton }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-chevron-left")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("product.backToCategory")) +
                                  " "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _vm.loadingCategories
                        ? _c("v-skeleton-loader", { attrs: { type: "image" } })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "product-title-container" },
                        [
                          _c(
                            "v-img",
                            {
                              attrs: {
                                "max-width": 580,
                                src: _vm.getProductImage(_vm.imageData)
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-center",
                                  staticStyle: {
                                    width: "51%",
                                    "margin-top": "5%"
                                  }
                                },
                                [
                                  _c("h2", { staticClass: "white--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("homepage.currency", {
                                          price: _vm.formatThousands(
                                            _vm.currentProduct.amountWithVat
                                          )
                                        })
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [_c("product-detail")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }